import React, { memo, useCallback, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import Animated, { useAnimatedStyle, withTiming, } from 'react-native-reanimated';
import { rem } from 'design-system/values';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { CircleContactClosable } from './CircleContact';
import { getFirstNameToShow, getLastNameToShow } from '../selectors';
import { isWeb } from '../../../constants';
const keyExtractor = (item, index) => (item?.recordID?.toString() || '') + index;
const SelectedContactsListComp = ({ contacts, onPress }) => {
    const renderCircleContact = useCallback(({ item }) => {
        const { thumbnailPath } = item;
        const handlePress = () => {
            onPress(item);
        };
        return (<CircleContactClosable onPress={handlePress} imageUrl={thumbnailPath} name={getFirstNameToShow(item) ?? '?'} lastName={getLastNameToShow(item)} medium/>);
    }, [onPress]);
    const style = useAnimatedStyle(() => ({
        backgroundColor: 'transparent',
        height: withTiming(contacts.length ? 50 : 0, { duration: 200 }),
    }), [contacts.length]);
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const contentContainerStyle = useMemo(() => [styles.selectedContacts, paddingHorizontalStyle], [paddingHorizontalStyle]);
    return (<Animated.FlatList initialNumToRender={15} windowSize={10} renderItem={renderCircleContact} data={contacts} showsHorizontalScrollIndicator={false} horizontal keyExtractor={keyExtractor} style={isWeb ? undefined : style} keyboardShouldPersistTaps="handled" contentContainerStyle={isWeb ? styles.selectedContacts : contentContainerStyle}/>);
};
export const SelectedContactsList = memo(SelectedContactsListComp);
const styles = StyleSheet.create({
    selectedContacts: {
        marginHorizontal: rem(16),
    },
});
